import { MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import { BtnOutlined, CmbWithTitle, Column, ContainerInside, ItemContainer, Items, LabelItem, ValueItem } from "../styled.components";
import FooterBtns from "../FooterBtns";
import { cloneObjectWithRegExp, downloadURI, formatDateWithoutTime, hotToast, validateData } from "utils";
import { InputsGroup } from "Components/Inputs";
import { InputModal } from "Components/V1/InputModal";
import Table from "Components/V1/Table";
import SaveIcon from "@mui/icons-material/Save";
import ServiceArchivo from "service/archivos";
import { ICombo } from "Interfaces/Generics";
import IRelUsuarioMarcaOperacion from "ITables/RelUsuarioMarcaOperacion";
import DragFile from "Components/V1/DragFile";
import IVersiones from "ITables/Versiones";






const VersionsFile = ({ row }: any) => {

    const [arrayVersions, setArrayVersions] = useState([])


    useEffect(() => {
        if (row) {
            ServiceArchivo.getListVersions({ setterFunc: setArrayVersions, idFileHead: row.idCargaArchivo })
        }
    }, [row])

    const downloadFile = (row:any) => {
        downloadURI(row.fullPath,row.url)
    }



    return (
        <ContainerInside>
            <Items>
                <Column ai={"flex-end"}>
                    <ItemContainer>
                        <LabelItem>Archivo:</LabelItem>
                        <ValueItem>{row.nombreArchivo}</ValueItem>
                    </ItemContainer>
                    <ItemContainer>
                        <LabelItem>Marca - Tipo Op:</LabelItem>
                        <ValueItem>{row.marcaTipoOperacion}</ValueItem>
                    </ItemContainer>
                    <ItemContainer>
                        <LabelItem>Fecha de Aplicación:</LabelItem>
                        <ValueItem>{ formatDateWithoutTime(row.fechaAplicacion)}</ValueItem>
                    </ItemContainer>
                </Column>
                <Column jc={"flex-start"} mh="40vh">
                    <Table
                        IColumns={IVersiones({
                            downloadFile
                        })}
                        IData={arrayVersions}
                        simply
                    />
                </Column>
            </Items>


        </ContainerInside >
    );
};

export default VersionsFile;
